<template>
  <div class="main" :class="'theme-'+theme">
  <div class="agreement">
    <h2 class="titleDiv">用户协议</h2>
    <ul>
      <li v-for="(li, index) in agreement" :key="'ag' + index">{{li.title}}</li>
    </ul>
    <div class="textcenter">
      <button @click="agree" class="normal-btn btn a_button">同意</button>
      <button @click="disagree" class="normal-btn btn d_button">不同意</button>
    </div>
  </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex';
export default {
  name: "agreement",
  data () {
    return {
      agreement: [
        {
          title: '01. 为避免出现争议，请您务必在下注之后查看「下注状况」。',
          type: 1
        },
        {
          title: '02. 任何投诉必须在开奖之前，本系统不接受任何开奖之后的投诉。',
          type: 1
        },
        {
          title: '03. 公布赔率时出现的任何打字错误或非故意人为失误，所有（相关）注单一律不算。',
          type: 1
        },
        {
          title: '04. 公布之所有赔率为浮动赔率，下注时请确认当前赔率及金额，下注确认后一律不能修改。',
          type: 1
        },
        {
          title: '05. 开奖后接受的投注，一律视为投机漏洞，[本局注单一律不返还本金及盈利]，敬请会员遵守游戏规则。',
          type: 1
        },
        {
          title: '06. 若本后台发现客户以不正当的手法投注或投注注单不正常，后台将有权「取消」相应之注单，客户不得有任何异议。',
          type: 1
        },
        {
          title: '07. 如因软件或线路问题导致交易内容或其他与账号设定不符合的情形，请在开奖前立即与本后台联络反映问题，否则本后台将以资料库中的数据为准。',
          type: 1
        },
        {
          title: '08. 倘若发生遭黑客入侵破坏行为或不可抗拒之灾害致网站故障或资料损坏、数据丢失等情况，后台将以资料库数据为依据。',
          type: 1
        },
        {
          title: '09. 各级管理人员及客户必须对本系统各项功能进行了解及熟悉，任何违反正常使用的操作，后台概不负责。',
          type: 1
        },
        {
          title: '10. 请认真了解各款彩票游戏规则。',
          type: 1
        },
        {
          title: '11. 如果会员信用额度超额或者为负数引起的争议，一律以公司处理为准。',
          type: 1
        },
        {
          title: '12. 客户有责任确保自己的账户及密码保密，如果因客户的账户、密码简单，或因泄露导致被盗用，造成的损失由客户本人承担；同时应立即通知本公司，并更改其个人详细资料。',
          type: 1
        },
        {
          title: '13. 若官方福彩中心开奖错误导致本系统采集数据同时出错情况下当期错误的所有注单以福彩中心官方网站更改后的数据为标准重新结算！在此特别声明，客户不得有任何异议。以上协议解释权归本系统所有。',
          type: 1
        }
      ]
    }
  },
  computed: {
    ...mapGetters('root', [
      'theme'
    ])
  },
  mounted () {
    this.queries = this.$route.query;
    // 绑定键盘事件，监听回车
    this.bodyListener = (e) => {
      if (e.keyCode === 13){
        this.agree();
      }
    }
    document.body.addEventListener('keyup', this.bodyListener)
  },
  beforeDestroy() {
    // 删除事件
    document.body.removeEventListener('keyup', this.bodyListener)
  },
  methods: {
    agree(){
      const path = this.queries.path || '';
      const category = this.queries.category_id || '';
      if(path!='' && category!='')
        this.$router.replace(this.queries.path+'&category_id='+category);
      else
        this.$router.replace('/home/lh');
    },
    disagree(){
      this.$router.replace(`/login`);
    }
  },
}
</script>

<style lang="stylus">
html ,body{
  height 100%
}
</style>
<style scoped lang="stylus">
/*@media screen and (max-width: 900px) { 
  .agreement {width: 35% !important;top: unset !important;left: unset !important;position:unset !important;padding:unset !important;transform:unset !important}
  .agreement h2{font-size:14px !important;padding:6px 0 5px !important;}
  .agreement ul{font-size:11px !important;margin-top:5px !important;line-height:18px !important;padding-right:5px !important;}
  .app_wrap .agreement button.btn{width:15vw;height:5vh;font-size:12px;border-radius:15vw;line-heght:20px;margin-top:10px}
}*/ 
@media screen and (max-width: 900px) { 
  /*.main{max-width:100vw !important}*/
  .agreement{width:95% !important}
}
.textcenter{text-align:center;}
.main{
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0 auto;
  background: linear-gradient(#6283dc,#aae1ea);
}
.main.theme-3{
  background:-moz-linear-gradient(34deg, #180022 10%, #762b85, #180022);
  background:-webkit-linear-gradient(34deg, #180022 10%, #762b85, #180022);
  background:linear-gradient(34deg, #180022 10%, #762b85, #180022);
}
.main.theme-3 .titleDiv{
  background:-moz-linear-gradient(to bottom, #180022 0%, #762b85 100%, #180022 100%);
  background:-webkit-linear-gradient(to bottom, #180022 0%, #762b85 100%, #180022 100%);
  background:linear-gradient(to bottom, #180022 0%, #762b85 100%, #180022 100%);
}
.main.theme-2 .titleDiv{
  background:-moz-linear-gradient(to bottom, #23621eeb 0%, #14861ec4 100%, #0d911e91 100%);
  background:-webkit-linear-gradient(to bottom, #23621eeb 0%, #14861ec4 100%, #0d911e91 100%);
  background:linear-gradient(to bottom, #23621eeb 0%, #14861ec4 100%, #0d911e91 100%);
}
.agreement{
  width:50%
  margin:0 auto
  background:#fff
  margin-top:20px;
  min-height:90%
}
.titleDiv {
    height:35px;
    line-height:35px;
    font-size: 22px;
    font-weight: bold;
    color: white;
    text-align: center;
    background: rgb(63,76,107);
    background: -moz-linear-gradient(top, rgba(63,76,107,1) 0%, rgba(92,103,201,1) 100%, rgba(63,76,107,1) 100%);
    background: -webkit-linear-gradient(top, rgba(63,76,107,1) 0%,rgba(92,103,201,1) 100%,rgba(63,76,107,1) 100%);
    background: linear-gradient(to bottom, rgba(63,76,107,1) 0%,rgba(92,103,201,1) 100%,rgba(63,76,107,1) 100%);
}
ul{padding:10px;}
li{line-height:25px;font-size:13px}
.btn{
  font-size: 14px;
    font-family: Arial;
    font-weight: bold;
    -moz-border-radius: 8px;
    -webkit-border-radius: 8px;
    border-radius: 8px;
    padding: 7px 14px;
    text-decoration: none;
    color: #ffffff;
    display: inline-block;
    margin-left:10px;
    margin-bottom:10px;
    border: 1px solid #469df5;
    background: -moz-linear-gradient( center top, #79bbff 5%, #4197ee 100% );
    background: -ms-linear-gradient( top, #79bbff 5%, #4197ee 100% );
    background: -webkit-gradient( linear, left top, left bottom, color-stop(5%, #79bbff), color-stop(100%, #4197ee) );
    background-color: #79bbff;
    text-shadow: 1px 1px 0px #287ace;
    -webkit-box-shadow: inset 1px 1px 0px 0px #cae3fc;
    -moz-box-shadow: inset 1px 1px 0px 0px #cae3fc;
    box-shadow: inset 1px 1px 0px 0px #cae3fc;
}
.main.theme-2 .btn{
    background: -moz-linear-gradient( center top, #14861ec4 5%, #0d911e91 100% );
    background: -ms-linear-gradient( top, #14861ec4 5%, #0d911e91 100% );
    background: -webkit-gradient( linear, left top, left bottom, color-stop(5%, #14861ec4), color-stop(100%, #0d911e91) );
    background-color: #14861ec4;
    border: 1px solid #0d911e91;
    text-shadow: 1px 1px 0px #0d911e91;
    -webkit-box-shadow: inset 1px 1px 0px 0px #9e9e9e;
    -moz-box-shadow: inset 1px 1px 0px 0px #9e9e9e;
    box-shadow: inset 1px 1px 0px 0px #9e9e9e;
}
.main.theme-3 .btn{
    background: -moz-linear-gradient( center top, #762b85 5%, #180022 100% );
    background: -ms-linear-gradient( top, #762b85 5%, #180022 100% );
    background: -webkit-gradient( linear, left top, left bottom, color-stop(5%, #762b85), color-stop(100%, #180022) );
    background-color: #762b85;
    border: 1px solid #180022;
    text-shadow: 1px 1px 0px #180022;
    -webkit-box-shadow: inset 1px 1px 0px 0px #9e9e9e;
    -moz-box-shadow: inset 1px 1px 0px 0px #9e9e9e;
    box-shadow: inset 1px 1px 0px 0px #9e9e9e;
}
/*
.agreement
  top 50%
  left 50%
  color #ffffff
  width 1000px
  padding 0 60px 40px 60px
  position absolute
  transform translate(-50%, -50%)
  box-sizing border-box
  background-color rgba(255,255,255,0.1)
  h2
    padding 40px 0 30px
    position relative
    font-size 36px
    &:after
      left 0
      width:143px;
      height:5px;
      bottom -5px
      display block
      content ""
      position absolute
      background-color #ffffff
  ul
    font-size 14px
    margin-top 36px
    line-height 30px
    padding-right 16px
  button.btn{
    color #fff
    width:120px;
    height:40px;
    font-size 16px
    margin-top 22px
    line-height 40px
    border-radius 30px;
    &.a_button{
      background-color #E64520
    }
    &.a_button:hover{
      background-color #fa3406
    }
    &.d_button{
      margin-left 8px
      background-color #29A8DB
    }
    &.d_button:hover{
      margin-left 8px
      background-color #08a1de
    }

  }*/
</style>



// WEBPACK FOOTER //
// src/pages/agreement/index.vue